import axios from 'axios';

export const defaultMetasAr = {
  metaAdherencia: 85,
  metaSeguimiento6m: 10,
  metaCalidadClinica: 60,
  metaAuditoriaDigital: 50,
  metaReduccionCosto: -10,
};

const metasCache = new Map();

const toNumber = (value, fallback) => {
  if (value === null || value === undefined) return fallback;
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

const normalizeMetas = (rawMetas = {}) => ({
  metaAdherencia: toNumber(rawMetas.metaAdherencia, defaultMetasAr.metaAdherencia),
  metaSeguimiento6m: toNumber(rawMetas.metaSeguimiento6m, defaultMetasAr.metaSeguimiento6m),
  metaCalidadClinica: toNumber(rawMetas.metaCalidadClinica, defaultMetasAr.metaCalidadClinica),
  metaAuditoriaDigital: toNumber(rawMetas.metaAuditoriaDigital, defaultMetasAr.metaAuditoriaDigital),
  metaReduccionCosto: toNumber(rawMetas.metaReduccionCosto, defaultMetasAr.metaReduccionCosto),
});

const loadFromPublicJson = async () => {
  try {
    const response = await fetch('/metas-ar.json', { cache: 'no-store' });
    if (!response.ok) throw new Error('No se pudo leer metas-ar.json');
    const data = await response.json();
    return normalizeMetas(data);
  } catch (error) {
    console.warn('Fallo carga de metas locales, usando defaults', error);
    return defaultMetasAr;
  }
};

export const fetchMetasAr = async (year) => {
  const cacheKey = year || 'default';
  if (metasCache.has(cacheKey)) {
    return metasCache.get(cacheKey);
  }

  try {
    const { data } = await axios.get('/artritis-dashboard/metas', {
      params: year ? { anio: year } : undefined,
    });
    const metas = normalizeMetas(data);
    metasCache.set(cacheKey, metas);
    return metas;
  } catch (error) {
    console.warn('Fallo endpoint /artritis-dashboard/metas, usando JSON local', error);
    const metas = await loadFromPublicJson();
    metasCache.set(cacheKey, metas);
    return metas;
  }
};
